import * as React from 'react';

import classnames from 'classnames';

import {CollapsibleChevron} from 'shells/card/collapsible-chevron';
import {colors} from 'shells/colors/colors';
import {Illustration} from 'shells/illustrations/illustration';
import {Stack} from 'shells/layout/stack/stack';
import {ProgressBar} from 'shells/progress-bar/progress-bar';
import {StatusBadge} from 'shells/status-badge/status-badge';

import type {OnboardingModuleFragment} from 'nutshell-graphql-types';

import {
    getStatusBadgeLevel,
    getStatusBadgeText,
    getPercentComplete,
    getIllustrationPath,
} from './helpers';
import {OnboardingModuleCardContent} from './onboarding-module-card-content';

import styles from './onboarding-module.module.css';

type Props = {
    module: OnboardingModuleFragment;
    isExpanded: boolean;
    setIsExpanded: (isExpanded: boolean) => void;
};

export function OnboardingModuleHeader(props: Props) {
    const statusBadgeLevel = getStatusBadgeLevel(props.module.status);
    const statusBadgeText = getStatusBadgeText(props.module.status);
    const illustrationPath = getIllustrationPath(props.module.type);

    const moduleHeaderContainerStyleNames = classnames(styles['module-header-container'], {
        [styles['is-expanded']]: props.isExpanded,
    });

    const rightSection = (
        <Stack spacing={16} isHorizontal={true} alignItems='center'>
            <StatusBadge level={statusBadgeLevel} text={statusBadgeText} size='small' />
            {props.module.status === 'IN_PROGRESS' && (
                <div className={styles['progress-bar-container']}>
                    <ProgressBar
                        percentComplete={getPercentComplete(props.module)}
                        height={8}
                        color={colors.blue}
                        backgroundColor={colors.blueLt}
                        roundedCorners={true}
                    />
                </div>
            )}
            <CollapsibleChevron isExpanded={props.isExpanded} />
        </Stack>
    );

    return (
        <button
            onClick={() => props.setIsExpanded(!props.isExpanded)}
            className={moduleHeaderContainerStyleNames}
        >
            <OnboardingModuleCardContent
                illustration={<Illustration src={illustrationPath} />}
                title={props.module.name}
                description={props.module.description}
                rightSection={rightSection}
            />
        </button>
    );
}
